import { ColorLevelTreshold, getLevelTreshold } from '../utils';

const polygonLevels: Record<ColorLevelTreshold, string> = {
  0: '#cecaca',
  10: '#DFAD46',
  20: '#F2412D',
  30: '#366BF2',
  40: '#CABDF7',
};

export const LevelPolygon = ({
  level,
  className,
}: {
  level: number;
  className?: string;
}) => {
  const levelTreshold = getLevelTreshold(level);

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="96"
      height="27"
      viewBox="0 0 96 27"
      fill="none"
      className={className}
    >
      <path
        d="M24.8889 1H24.4335L24.1346 1.34348L3.2457 25.3435L1.80391 27H4H92H94.1961L92.7543 25.3435L71.8654 1.34348L71.5665 1H71.1111H24.8889Z"
        fill="url(#fill)"
        stroke={`url(#stroke-${polygonLevels[levelTreshold]})`}
        strokeWidth="2"
      />
      <defs>
        <linearGradient
          id="fill"
          x1="48"
          y1="2"
          x2="48"
          y2="26"
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset="1" stopColor="#212121" />
        </linearGradient>
        <linearGradient
          id={`stroke-${polygonLevels[levelTreshold]}`}
          x1="48"
          y1="2"
          x2="48"
          y2="26"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor={polygonLevels[levelTreshold]} />
          <stop offset="1" stopColor="#101010" stopOpacity="0" />
        </linearGradient>
      </defs>
    </svg>
  );
};
